.modal-dialog {
  --modal-dialog-padding: 1.5rem;
  --modal-dialog-padding-mobile: 1.25rem;

  background: var(--color-uva-white);
  box-shadow:
    0 2px 2px hsl(0deg 0% 0% / 6%),
    0 4px 3px hsla(0deg 0% 0% / 7%);
  display: flex;
  flex-direction: column;

  /* dynamic view height needed to adapt for possible auto hiding of mobile address bar */
  height: 100dvh;
  position: relative;
  width: 100vw;
}

.modal-dialog--padded {
  padding: 0;
}

.modal-dialog__content {
  display: flex;
  flex-direction: column;
  height: 100svh;
  justify-content: space-between;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 var(--modal-dialog-padding-mobile);
  width: 100%;
}

.modal-dialog__children {
  padding-bottom: var(--modal-dialog-padding-mobile);
}

.modal-dialog__title {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  margin: 0 var(--modal-dialog-padding-mobile) 0 0;
  padding: var(--modal-dialog-padding-mobile);
}

.modal-dialog--confirm {
  padding: var(--modal-dialog-padding-mobile) 0 0;
}

.modal-dialog__buttons {
  background-color: var(--color-uva-white);
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: flex-start;
  margin: 0 calc(-1 * var(--modal-dialog-padding-mobile));
  padding: var(--modal-dialog-padding-mobile);
  position: sticky;
  right: 0;
}

.modal-dialog__buttons--border {
  border-top: 1px solid var(--color-grey-300);
}

.modal-dialog__buttons::before {
  background: linear-gradient(to top, rgba(0 0 0 / 30%), rgba(0 0 0 / 0%));
  bottom: 100%;
  content: "";
  height: 10px;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  transition: opacity 0.4s ease-out;
}

.modal-dialog__buttons--shadow::before {
  opacity: 1; /* Show the shadow when content is scrollable and not scrolled to the bottom */
}

.modal-dialog__close {
  position: absolute;
  right: var(--modal-dialog-padding-mobile);
  top: var(--modal-dialog-padding-mobile);
}

@media (min-width: 28rem) and (min-height: 28rem) {
  .modal-dialog {
    height: unset;
    max-height: 100svh;
    max-width: 100vw;
  }

  .modal-dialog--padded {
    width: 34.25rem;
  }

  .modal-dialog--small {
    width: 27.5rem;
  }

  .modal-dialog--regular {
    width: 30rem;
  }

  .modal-dialog--medium {
    width: 36rem;
  }

  .modal-dialog--large {
    width: 65.375rem;
  }

  .modal-dialog__title {
    margin-right: var(--modal-dialog-padding);
    padding: var(--modal-dialog-padding);
  }

  .modal-dialog__content {
    height: unset;
    padding: 0 var(--modal-dialog-padding);
  }

  .modal-dialog--content-with-buttons {
    margin-bottom: 5.75rem;
  }

  .modal-dialog__children {
    padding-bottom: var(--modal-dialog-padding);
  }

  .modal-dialog--confirm {
    padding: var(--modal-dialog-padding) 0 0;
  }

  .modal-dialog__buttons {
    margin: unset;
    padding: var(--modal-dialog-padding);
    position: absolute;
    width: inherit;
  }

  .modal-dialog__close {
    position: absolute;
    right: var(--modal-dialog-padding);
    top: var(--modal-dialog-padding);
  }
}
